import { find } from 'lodash';
import { createSelector } from 'reselect';
export var getTags = function (state) { return state.tags; };
export var getMostPopularTags = function (state) { return state.mostPopularTags; };
var getTagSlug = function (state, tagSlug) { return tagSlug; };
export var getTagBySlug = createSelector([getTags, getTagSlug], function (tags, tagSlug) { return find(tags, function (tag) { return tag.slug === tagSlug; }); });
